module.exports = __webpack_public_path__ + "static/media/zippyclip-4.8130922e.jpg";